import { render, staticRenderFns } from "./ServiceElderByAbility.vue?vue&type=template&id=c974dde6&scoped=true&"
import script from "./ServiceElderByAbility.vue?vue&type=script&lang=js&"
export * from "./ServiceElderByAbility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c974dde6",
  null
  
)

export default component.exports